// extracted by mini-css-extract-plugin
module.exports = {"BirdPlayer":"BirdPlayer_BirdPlayer__1ZaSz"};